"use client";

import { useContext, useState, forwardRef } from "react";

import { useLanguageChange } from "@hooks/use-language-change";
import LanguageSelector from "@stadium/ui/src/components/language-selector";

import styles from "./main.module.scss";
import { InternalButton } from "@sharedComponents/buttons";
import { WeglotContext } from "@stadium/services/weglot/provider";
import PreferredColorsDropdown from "@components/create-swag/preferred-colors/dropdown";
import ExitCreateSwagConfirmModal from "@components/create-swag/add-logo/modals/exit-create-swag-confirm-modal";

const MAIN_CREATE_SWAG_HEADER_EXIT_BODY =
  "If you exit now, we'll save the products you've selected. You can come back anytime to start designing your collection.";

const CreateSwagHeaderRightSection = forwardRef(
  ({ isColorDropdownOpen, openPreferredColorsDropdown }, ref) => {
    const [showExitModal, setShowExitModal] = useState(false);

    const { instance: Weglot, availableLanguages } = useContext(WeglotContext);

    const { changeLang, langInUrl } = useLanguageChange();

    const handleExitCreateSwag = () => setShowExitModal(true);

    const renderPreferredColors = () => {
      return (
        <PreferredColorsDropdown.Toggle
          isOpen={isColorDropdownOpen}
          openPreferredColorsDropdown={openPreferredColorsDropdown}
          ref={ref}
        />
      );
    };

    const renderLanguageSelector = () => {
      return (
        <div className={styles.languageSelectorContainer}>
          <LanguageSelector
            availableLanguages={availableLanguages}
            weglotInstance={Weglot}
            onSelectLang={changeLang}
            langInUrl={langInUrl}
            className={styles.languageSelector}
          />
        </div>
      );
    };
    return (
      <div className={styles.createSwagHeaderRightSection}>
        {renderPreferredColors()}
        {renderLanguageSelector()}
        <InternalButton styleType="link" onClick={handleExitCreateSwag} className={styles.exitLink}>
          Exit
        </InternalButton>
        {showExitModal && (
          <ExitCreateSwagConfirmModal
            closeModal={() => setShowExitModal(false)}
            bodyText={MAIN_CREATE_SWAG_HEADER_EXIT_BODY}
          />
        )}
      </div>
    );
  },
);

export default CreateSwagHeaderRightSection;
